import { Pipe, PipeTransform } from '@angular/core';
import { OrderContext } from 'graphql/libs/shopping-cart-front/src/graphql';
import {
  getSessionStatsDisplayRangeLabel,
  getSessionStatsDisplayTitle,
  getSessionStatsPeriod,
  getSessionStatsTopOrderSessions,
  getSessionStatsTopPublicSessionOrganizationGroupsByOrders,
  getSessionStatsTopPublicSessionOrganizationsByOrders,
  getSessionStatsVisits,
} from './session-stats.helpers';
import {
  OrderDetailsItem,
  ParsedDetails,
  SessionStatsDetails,
  SessionStatsPeriod,
  TopPublicSessionOrganizationDetailsItem,
  TopPublicSessionOrganizationGroupDetailsItem,
  VisitDetails,
} from './session-stats.model';

@Pipe({
    name: 'sessionStatsPeriod',
    standalone: false
})
export class SessionStatsPeriodPipe implements PipeTransform {
  transform(
    details: SessionStatsDetails | null | undefined,
  ): SessionStatsPeriod {
    return getSessionStatsPeriod(details);
  }
}

@Pipe({
    name: 'sessionStatsDisplayTitle',
    standalone: false
})
export class SessionStatsDisplayTitlePipe implements PipeTransform {
  transform(period: SessionStatsPeriod | null | undefined): string {
    return getSessionStatsDisplayTitle(period);
  }
}

@Pipe({
    name: 'sessionStatsDisplayRangeLabel',
    standalone: false
})
export class SessionStatsDisplayRangeLabelPipe implements PipeTransform {
  transform(details: SessionStatsDetails | null | undefined): string | null {
    return getSessionStatsDisplayRangeLabel(details);
  }
}

@Pipe({
    name: 'sessionStatsVisits',
    standalone: false
})
export class SessionStatsVisitsPipe implements PipeTransform {
  transform(
    parsedDetails: ParsedDetails | null | undefined,
    context: OrderContext | null | undefined,
  ): ReadonlyArray<VisitDetails> {
    return getSessionStatsVisits(parsedDetails, context);
  }
}

@Pipe({
    name: 'sessionStatsTopOrderSessions',
    standalone: false
})
export class SessionStatsTopOrderSessionsPipe implements PipeTransform {
  transform(
    parsedDetails: ParsedDetails | null | undefined,
  ): ReadonlyArray<OrderDetailsItem> {
    return getSessionStatsTopOrderSessions(parsedDetails);
  }
}

@Pipe({
    name: 'sessionStatsTopPublicSessionOrganizationsByOrders',
    standalone: false
})
export class SessionStatsTopPublicSessionOrganizationsByOrdersPipe
  implements PipeTransform
{
  transform(
    parsedDetails: ParsedDetails | null | undefined,
  ): ReadonlyArray<TopPublicSessionOrganizationDetailsItem> {
    return getSessionStatsTopPublicSessionOrganizationsByOrders(parsedDetails);
  }
}

@Pipe({
    name: 'sessionStatsTopPublicSessionOrganizationGroupsByOrders',
    standalone: false
})
export class SessionStatsTopPublicSessionOrganizationGroupsByOrdersPipe
  implements PipeTransform
{
  transform(
    parsedDetails: ParsedDetails | null | undefined,
  ): ReadonlyArray<TopPublicSessionOrganizationGroupDetailsItem> {
    return getSessionStatsTopPublicSessionOrganizationGroupsByOrders(
      parsedDetails,
    );
  }
}
